module.exports = __webpack_public_path__ + "img/inspector-perfectionist-1.2e3f64a1.svg";